import { useMemo } from 'react';
import {
  NavigationSection,
  SectionStatus,
} from '@/features/submission_forms/types';

interface UseVisibleNavigationSectionsOptions {
  navigationSections: NavigationSection[];
  visibleSections: Set<string>;
  sectionStatusMap: Map<string, string>;
}

/**
 * Hook to compute visible navigation sections with their statuses
 * Filters sections based on visibility and enriches with status from backend
 */
export const useVisibleNavigationSections = ({
  navigationSections,
  visibleSections,
  sectionStatusMap,
}: UseVisibleNavigationSectionsOptions): NavigationSection[] => {
  return useMemo(
    () =>
      navigationSections
        .filter(section => visibleSections.has(section.id))
        .map(section => ({
          ...section,
          status: (sectionStatusMap.get(section.id) ||
            'not_started') as SectionStatus,
        })),
    [navigationSections, visibleSections, sectionStatusMap]
  );
};
